import { FC, useState } from 'react';
import { Button, Checkbox, Modal, StatusDropdown, Table } from '@components';
import { SuccessIcon } from '@assets/svg';
import { ColumnType } from 'antd/lib/table';
import { useQuery } from 'react-query';
import { useRepository } from '@context';
import { BookingArchive, BookingArchiveResponse } from '@common/interfaces';
import { format } from 'date-fns';
import { DEFAULT_USER_DATE_FORMAT } from '@common/constants';
import css from './styles.module.scss';

interface IArchivingModal {
  closeModal: () => void;
  submitRequest: (archive_notification: boolean) => void;
  facilityId: string;
}

const ArchivingModal: FC<IArchivingModal> = ({ closeModal, submitRequest, facilityId }) => {
  const { facilityRepository } = useRepository();
  const [isNotif, setIsNotif] = useState(false);

  const { data, isLoading } = useQuery<BookingArchiveResponse>(['bookings', facilityId], () =>
    facilityRepository.getAdminFacilitiesBookings(facilityId)
  );

  const columns: ColumnType<BookingArchive>[] = [
    {
      dataIndex: 'request_number',
      key: 'request_number',
      title: 'Request #',
    },
    {
      dataIndex: 'requesting_agency',
      key: 'requesting_agency',
      title: 'Agency',
    },
    {
      dataIndex: 'created',
      key: 'created',
      title: 'Request date',
      render: (_, { created }) => format(new Date(created), DEFAULT_USER_DATE_FORMAT),
    },
    {
      dataIndex: 'type_of_asset',
      key: 'type_of_asset',
      title: 'Type',
    },
    {
      dataIndex: 'plate_number',
      key: 'plate_number',
      title: 'Plate/ID',
    },
    {
      dataIndex: 'jobcard_number',
      key: 'jobcard_number',
      title: 'Jobcard #',
    },
    {
      dataIndex: 'state',
      key: 'state',
      title: 'Status',
      render: (_, { state }) => <StatusDropdown status={state} />,
    },
  ];

  const bookings = data?.bookings || [];

  return (
    <Modal
      loading={isLoading}
      className={css.modal}
      title='Workshop to be archived'
      closeModal={closeModal}
      variant='dark'
    >
      <Modal.Content>
        Total count of bookings: <b>{bookings.length}</b>
        <Table scroll={{ y: 360 }} className={css.table} columns={columns} data={bookings} variant='dark' />
        <Checkbox
          checked={isNotif}
          onChange={setIsNotif}
          label='If you select this checkbox, a notification email will be sent to all users who have access to this Digital Office.'
        />
      </Modal.Content>
      <Modal.Footer>
        <Button text='Cancel' variant='transparent' onClick={closeModal} />
        <Button
          text='Submit'
          iconR={<SuccessIcon />}
          variant='forest'
          onClick={() => {
            submitRequest(isNotif);
            closeModal();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ArchivingModal;
